module.exports = __webpack_public_path__ + "assets/img/5_1164.ed3f6965.jpg";